module.exports = __webpack_public_path__ + "media/images/basic_logos/bargraph1-558b83e49fe45b73ceb77785849891b1.png";